import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeWorkPositions  {
    _originalTypeClassName = "zERP.BO.EmployeeWorkPositions";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeWorkPositions.translate = translateService;
}
this.Id = null;
this.companyID = null;
this.FirstName = null;
this.CompanyName = null;
this.DepartmentName = null;
this.EmployeeDepPositionName = null;
this.WorkPositionName = null;
this.DepPosTitleDescription = null;
this.OccupiedPositions = null;
this.AvailablePositions = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
companyID:any;
FirstName:any;
CompanyName:any;
DepartmentName:any;
EmployeeDepPositionName:any;
WorkPositionName:any;
DepPosTitleDescription:any;
OccupiedPositions:any;
AvailablePositions:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}